module.exports = __webpack_public_path__ + "assets/img/change.a8b21a7a.svg";